module.exports = __webpack_public_path__ + "static-portal/img/yhz-zxhy2.671831a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yhz-zxhy2.jpg
// module id = RM6C
// module chunks = 4